export default __webpack_public_path__ + "static/media/contractor-dashboard-instructions.c306e090.png";